
    /**
    * 加载商品中心 类目
    *
    **/

    // @ts-nocheck
    import request from '../utils/request/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqNewSupplierCategoryCategoryNo36890 {}
    /**
 * YResult<YListData<CategoryTreeNodeResult>> :YResult
 */
export class IResNewSupplierCategoryCategoryNo36890 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * 类目编号
       */
      categoryNo?: {};
      /**
       * 类目名称
       */
      categoryName?: {};
      /**
       * 类目级别：1-4
       */
      level?: {};
      /**
       * 排序值
       */
      sortNum?: {};
      /**
       * 父节点编号
       */
      parentNo?: {};
      /**
       * 图片地址
       */
      icon?: {};
      /**
       * 是否是叶子节点：0-否，1-是
       */
      isLeaf?: {};
      /**
       * 是否有子节点：0-否1-是
       */
      hasChild?: {};
      /**
       * 类目树编号路径
       */
      categoryNoPath?: {};
      /**
       * 资质是否必填1：必填0：非必填（默认必填）
       */
      qualificationMust?: {};
    }[];
    totalNumber?: {};
    totalPage?: {};
    rowId?: {};
    hasNext?: {};
    pageSize?: {};
    pageIndex?: {};
  };
  exceptionMsg?: {};
}
    const http: Serve<IReqNewSupplierCategoryCategoryNo36890, IResNewSupplierCategoryCategoryNo36890> = (data?) => {
      const No = data.categoryNo
      return request({
        method: 'GET',
        url: `/ywwl-supply-chain/new/supplier/category/${No}`,
        // params: data
      })
    }
    export default http
